export default class CategoryList {
    static init(): void {
        this.categoryListToggle();
        this.mobileCategoryListToggle();
    }

    static categoryListToggle(): void {
        document.querySelectorAll<HTMLElement>('.js-category-list').forEach((categoryListBlock) => {
            const categoryListItems = categoryListBlock.querySelectorAll<HTMLElement>('.category-list-item');

            if (categoryListItems.length > 0) {
                categoryListItems.forEach((categoryListItem) => {
                    const categoryListTrigger =
                        categoryListItem.querySelector<HTMLElement>('.category-list-item-trigger');
                    const categoryListContent =
                        categoryListItem.querySelector<HTMLElement>('.category-list-item-content');

                    if (categoryListTrigger && categoryListContent) {
                        // Inicializace stylů pro hladkou animaci
                        categoryListContent.style.overflow = 'hidden';

                        // Kontrola, zda je item již aktivní při inicializaci
                        if (categoryListItem.classList.contains('is-active')) {
                            categoryListContent.style.maxHeight = `${categoryListContent.scrollHeight}px`;
                        } else {
                            categoryListContent.style.maxHeight = '0px';
                        }

                        categoryListTrigger.addEventListener('click', (e: Event) => {
                            // Kontrola, zda se nekliklo na title nebo jeho potomky
                            const target = e.target as HTMLElement;
                            if (target.closest('.category-list-item__title')) {
                                return; // Neklikáme, pokud je target title - ponecháváme výchozí chování
                            }

                            e.preventDefault(); // Zablokujeme výchozí chování pouze pro non-title kliky

                            const isActive = categoryListItem.classList.contains('is-active');
                            categoryListContent.style.transition = 'max-height 0.25s ease'; // Přidání přechodu pro animaci až sem aby se nespustila při načtení stránky

                            if (isActive) {
                                categoryListItem.classList.remove('is-active');
                                categoryListContent.style.maxHeight = '0px';
                            } else {
                                categoryListItem.classList.add('is-active');
                                categoryListContent.style.maxHeight = `${categoryListContent.scrollHeight}px`;
                            }
                        });
                    }
                });
            }
        });
    }

    static mobileCategoryListToggle(): void {
        const categoryListMobileItem = document.querySelector<HTMLElement>('.category-list-item-mobile');
        const categoryMobileItemTrigger = document.querySelector<HTMLElement>('.category-list-item-trigger-mobile');
        const categoryMobileItemContent = document.querySelector<HTMLElement>('.category-list-content');

        if (!categoryMobileItemTrigger || !categoryMobileItemContent || !categoryListMobileItem) {
            return;
        }

        let clickHandler: ((e: Event) => void) | null = null;

        // Funkce pro kontrolu breakpointu a aktivaci/deaktivaci
        const handleResize = (): void => {
            const isMobile = window.innerWidth <= 767;

            if (isMobile) {
                // Aktivace pro mobilní zařízení
                if (!clickHandler) {
                    // Inicializace stylů pro hladkou animaci
                    categoryMobileItemContent.style.overflow = 'hidden';

                    // Kontrola, zda je item již aktivní při inicializaci
                    if (categoryMobileItemTrigger.classList.contains('is-active')) {
                        categoryMobileItemContent.style.maxHeight = `${categoryMobileItemContent.scrollHeight}px`;
                    } else {
                        categoryMobileItemContent.style.maxHeight = '0px';
                    }

                    // Vytvoření a přidání event listeneru
                    clickHandler = (e: Event) => {
                        e.preventDefault();

                        const isActive = categoryMobileItemTrigger.classList.contains('is-active');
                        categoryMobileItemContent.style.transition = 'max-height 0.25s ease';

                        if (isActive) {
                            categoryMobileItemTrigger.classList.remove('is-active');
                            categoryListMobileItem.classList.remove('is-active');
                            categoryMobileItemContent.style.maxHeight = '0px';
                             categoryMobileItemContent.style.paddingTop = '0px';
                        } else {
                            categoryMobileItemTrigger.classList.add('is-active');
                            categoryListMobileItem.classList.add('is-active');
                            categoryMobileItemContent.style.maxHeight = `100%`;
                            categoryMobileItemContent.style.paddingTop = '10px';
                        }
                    };

                    categoryMobileItemTrigger.addEventListener('click', clickHandler);
                }
            } else {
                // Deaktivace pro desktop
                if (clickHandler) {
                    categoryMobileItemTrigger.removeEventListener('click', clickHandler);
                    clickHandler = null;
                }

                // Reset stylů pro desktop
                categoryMobileItemContent.style.maxHeight = '';
                categoryMobileItemContent.style.overflow = '';
                categoryMobileItemContent.style.transition = '';
                categoryMobileItemContent.style.paddingTop = '';
                categoryMobileItemTrigger.classList.remove('is-active');
                categoryListMobileItem.classList.remove('is-active');
            }
        };

        // Inicializace při načtení
        handleResize();

        // Přidání resize event listeneru
        window.addEventListener('resize', handleResize);
    }
}
